import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Gallery from "./components/Gallery";
import Styles from "./components/Styles";
import Hot from "./components/Hot";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Gallery />
        <Styles />
        <Hot />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}